"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var QuickLinkFullImage = function QuickLinkFullImage() {
  return (0, _preact.h)("svg", {
    width: "100%",
    viewBox: "0 0 52 44",
    fill: "none"
  }, (0, _preact.h)("g", null, (0, _preact.h)("rect", {
    width: "52",
    height: "44",
    fill: "white"
  }), (0, _preact.h)("rect", {
    width: "52",
    height: "19",
    fill: "#0069FF",
    rx: "4"
  }), (0, _preact.h)("rect", {
    x: "0",
    y: "17",
    width: "52",
    height: "2",
    fill: "#0069FF"
  }), (0, _preact.h)("rect", {
    x: "5.80371",
    y: "24.4023",
    width: "40.3927",
    height: "6.23721",
    rx: "3.1186",
    fill: "#9599A2"
  }), (0, _preact.h)("rect", {
    x: "12.7129",
    y: "34.3174",
    width: "26.5741",
    height: "4.6779",
    rx: "2.33895",
    fill: "#BFC2C8"
  })), (0, _preact.h)("rect", {
    x: "0.5",
    y: "0.5",
    width: "51",
    height: "43",
    rx: "3.5",
    stroke: "#D5D6DA"
  }));
};

var _default = QuickLinkFullImage;
exports.default = _default;